import { useNavigate } from 'react-router';
import { dispatch, restoreAll } from '../../store';
import { LocalStorage } from '../../util/LocalStorage';
import { useContainer } from '../useContainer';
import { closeAllDropdowns } from '../../store/slices/navigation/navigation.slice';

export const useLogout = () => {
    const navigate = useNavigate();
    const storage: LocalStorage = useContainer(LocalStorage);

    const logoutUserHandler = (clearCacheCallback?: () => void) => {
        dispatch(closeAllDropdowns());

        storage.removeAuth();

        dispatch(restoreAll());

        if (clearCacheCallback) {
            clearCacheCallback();
        }

        navigate('/sign-in');
    };

    return { logoutUser: logoutUserHandler };
};
